import React, { useState, useEffect, useRef } from "react";
import "./FloatingButton.css";
import rag from "../../assets/DocplaceAIn.svg";
import AgentChat from "./Agent";

export const DocAssistantButton = (props) => {
  const isDocViewerPage = window.location.pathname.includes("docViewer");
  const [showAgent, setShowAgent] = useState(false);
  const [buttonVisible, setButtonVisible] = useState(true);
  const containerRef = useRef(null);

  const handleClick = () => {
    if (isDocViewerPage) {
      props.onShowAgent && props.onShowAgent();
    } else {
      setShowAgent(!showAgent);
      if (!showAgent) {
        // When opening, fade button to the right
        setButtonVisible(false);
      }
    }
  };

  const handleCloseAgent = () => {
    setShowAgent(false);
    // When closing, fade button back in from the right
    setTimeout(() => {
      setButtonVisible(true);
    }, 100);
  };

  // Handle clicking outside to close
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        containerRef.current &&
        !containerRef.current.contains(event.target) &&
        showAgent
      ) {
        handleCloseAgent();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showAgent]);
  return (
    <div ref={containerRef}>
      {showAgent && (
        <div className="assistant-container">
          <AgentChat search={true} onCloseChat={handleCloseAgent} />
        </div>
      )}
      {/* Floating Button */}
      <div
        className={`floating-button ${buttonVisible ? "fade-in" : "fade-out"}`}
        onClick={handleClick}
      >
        <span className="text">DocPlace AI</span>
        <img
          src={rag} // Replace with your actual image path
          alt="DocAssistant"
          className="icon"
        />
      </div>
    </div>
  );
};

export default DocAssistantButton;
